<template>
  <div class="central-control" v-loading="loading" :element-loading-text="$t('ctcicc1')">
    <div class="central-control-top">
      <el-button v-if="edit" @click="editIt" class="el-button" type="primary">
        {{$t('terminal.EditInstruction')}}
      </el-button>
      <el-button v-else @click="editVisible = true;editCheck = true;form={}" class="el-button" type="primary">
        {{$t('terminal.AddInstruction')}}
      </el-button>
    </div>
    <div class="central-control-bottom">
      <div v-if="edit">
        <el-button style="margin: 16px 8px;" v-for="(device,index) in deviceList" :key="index" @click="checkEdit(index)" type="primary">
          {{device.name}}
        </el-button>
      </div>
      <div v-else style="width: 100%;height: 100%" class="flex-d-b-c">
        <div style="width: 100%;height: 100%">
          <el-table :data="deviceList" v-model="selectedRows" :highlight-current-row="true" @row-click="handleSelectionChange" :row-class-name="tableRowClassName" style="width: 100%" height="100%" ref="deviceList">
            <el-table-column type="index" width="50">
            </el-table-column>
            <el-table-column prop="name" :label="$t('ctcicc2')">
            </el-table-column>
            <el-table-column prop="contentType" :formatter="formatContentType" :label="$t('ctcicc3')">
            </el-table-column>
            <el-table-column prop="type" :formatter="formatType" label="数据类型">
            </el-table-column>
            <el-table-column prop="content" label="协议内容">
            </el-table-column>
            <el-table-column prop="ip" label="IP">
            </el-table-column>
            <el-table-column prop="port" label="PORT">
            </el-table-column>
            <el-table-column :label="$t('ctcicc6')">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">{{$t('ctcicc7')}}</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{$t('ctcicc8')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin: 16px;">
          <el-button @click="edit = true" type="primary">{{$t('ctcicc9')}}</el-button>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('ctcicc5')" :visible.sync="editVisible" width="30%" :modal=false :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item :label="$t('ctcicc2')">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ctcicc4')">
          <el-select v-model="form.type">
            <el-option v-for="item in Type" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据类型 ">
          <el-select v-model="form.contentType">
            <el-option v-for="item in contentType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协议内容">
          <el-input type="textarea" v-model="form.content"></el-input>
        </el-form-item>
        <template v-if="form.type === 1 || form.type === 2">
          <el-form-item label="IP">
            <el-input v-model="form.ip"></el-input>
          </el-form-item>
          <el-form-item label="PORT">
            <el-input v-model="form.port"></el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false;">{{$t('ctcicc10')}}</el-button>
        <el-button type="primary" @click="addOrder">{{$t('ctcicc11')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import {uriEncode} from "@/assets/scripts/uriEncode";
// const detailCommand = "/admin/Command/generalCommand";
export default {
  name: "CentralControl",
  props: {
    currentDetail: {
      type: Object
    }
  },
  data() {
    return {
      deviceList: [],//解析出来的数据
      edit: true,//编辑状态
      editVisible: false,//输入框
      editCheck: false,//判断是否为添加指令
      editIndex: 0,//当前选中的index
      selectedRows: -1,//列表中选中的index
      loading: true,//
      Type: [
        { label: 'UDP', value: 1 },
        { label: 'TCP', value: 2 },
        { label: '232', value: 3 },
        { label: '485_1', value: 4 },
        { label: '485_2', value: 5 },
      ],
      contentType: [
        { label: this.$t('ctcicc12'), value: 1 },
        { label: this.$t('ctcicc13'), value: 2 }
      ],
      form: {
        name: "",
        contentType: "",
        type: "",
        content: "",
        ip: "",
        port: ""
      }
    }
  },
  methods: {
    init() {
      this.myWebSocket.onmessage = (val) => {
        let upresult = JSON.parse(val.data);
        if (upresult.type === "invoke_method") {
          if (upresult.data.uri && upresult.data.uri === "getCmdList") {
            let data = JSON.parse(upresult.data.response);
            this.deviceList = data.data;
            this.loading = false;
          }
          if (upresult.data.uri && upresult.data.uri === "sendCmdIndex") {
            const { code, message } = JSON.parse(upresult.data.response);
            console.log(message);
            this.$msg({ message: code == 200 ? this.$t('ctcicc14') : this.$t('ctcicc15'), type: "success", showClose: true });
          }

          if (upresult.data.uri && upresult.data.uri === "setCmdList") {
            const { code, message } = JSON.parse(upresult.data.response);
            console.log(message);
            this.$msg({ message: code == 200 ? this.$t('ctcicc16') : this.$t('ctcicc17'), type: "success", showClose: true });
          }
        }
      }
    },

    sendCmd(commands_info, type = "set") {

      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, res => {
        console.log(res);
      });
    },
    //getCmdList
    getData() {
      // this.$http.post(detailCommand, {
      //   device_select_mode: "multiple",
      //   devices_info: "%5B%7B%22id%22%3A1596%2C%22sn%22%3A%22KB1223042190%22%2C%22type_id%22%3A1%2C%22name%22%3A%22KPB12-23042190%22%2C%22cache%22%3A%7B%7D%7D%5D",
      //   commands_info: "%5B%7B%22type%22%3A%22invoke_method%22%2C%22data%22%3A%7B%22methodName%22%3A%22getCmdList%22%2C%22methodParams%22%3A%7B%7D%7D%7D%5D",
      //   request_type: "set"
      // },
      // );
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getCmdList", methodParams: {} } }]);
    },
    AddIt() {
      this.editVisible = true;
      this.editCheck = true;
      this.form = {
        name: "",
        contentType: "",
        type: "",
        content: "",
        ip: "",
        port: ""
      }
    },
    editIt() {
      this.edit = false;
    },
    //编辑
    handleEdit(index, row) {
      this.editIndex = index
      this.form = row;
      this.editCheck = false;
      this.editVisible = true;
    },
    //删除
    handleDelete(index) {
      this.deleteData(index)
      this.postData(this.deviceList)
    },

    addOrder() {
      if (this.editCheck === true) { //新加数据
        this.deviceList.push(this.form);
        this.postData(this.deviceList);
      } else if (this.editCheck === false) {//修改数据
        this.deviceList[this.editIndex] = this.form
        this.postData(this.deviceList);
      }
    },


    //替换devicelist里的内容
    deleteData(index) {
      this.deviceList.splice(index, 1);
      this.deviceList = this.deviceList.slice();
    },

    //sendCmdindex
    checkEdit(index) {
      console.log(index);

      // if (index > -1) {
      //   var commands_info = [{ "type": "invoke_method", "data": { "methodName": "sendCmdIndex", "methodParams": { "index": parseInt(index) - 1 } } }]
      //   this.$http.post(detailCommand, {
      //     device_select_mode: "multiple",
      //     devices_info: "%5B%7B%22id%22%3A1596%2C%22sn%22%3A%22KB1223042190%22%2C%22type_id%22%3A1%2C%22name%22%3A%22KPB12-23042190%22%2C%22cache%22%3A%7B%7D%7D%5D",
      //     commands_info: encodeURIComponent(JSON.stringify(commands_info)),
      //     request_type: "set"
      //   },
      //   );
      // }
      // index从1开始
      this.sendCmd([{ type: "invoke_method", data: { methodName: "sendCmdIndex", methodParams: { index: index + 1 } } }]);
    },
    handleClose() {
      this.editVisible = false
    },
    //setCmdList
    postData(data) {
      console.log(data);
      // this.deviceList.push(data);
      // var commands_info = [{
      //   "type": "invoke_method",
      //   "data": {
      //     "methodName": "setCmdList",
      //     "methodParams": {
      //       "postData": JSON.stringify(data)
      //     }
      //   }
      // }]
      // this.$http.post(detailCommand, {
      //   device_select_mode: "multiple",
      //   devices_info: "%5B%7B%22id%22%3A1596%2C%22sn%22%3A%22KB1223042190%22%2C%22type_id%22%3A1%2C%22name%22%3A%22KPB12-23042190%22%2C%22cache%22%3A%7B%7D%7D%5D",
      //   commands_info: encodeURIComponent(JSON.stringify(commands_info)),
      //   request_type: "set"
      // },
      // );
      this.sendCmd([
        {
          type: "invoke_method",
          data: {
            methodName: "setCmdList",
            methodParams: { postData: JSON.stringify(data) }
          }
        }
      ]);
      this.editVisible = false;
    },
    //表单
    handleSelectionChange(row) {
      this.selectedRows = row.row_index
    },
    tableRowClassName({ row, rowIndex }) {
      row.row_index = rowIndex;
    },
    formatType(type) {
      if (type.type === 1) {
        return 'UDP';
      } else if (type.type === 2) {
        return 'TCP';
      } else if (type.type === 3) {
        return '232';
      } else if (type.type === 4) {
        return '485_1';
      } else if (type.type === 5) {
        return '485_2';
      } else {
        return type.type;
      }
    },
    formatContentType(contentType) {
      if (contentType.contentType === 1) {
        return '字符串';
      } else if (contentType.contentType === 2) {
        return '16进制';
      } else {
        return contentType.contentType;
      }
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    },
  },
  watch: {
    deviceList() {
      this.$nextTick(() => {
        // 手动重新渲染表格
        if (this.$refs.deviceList) {
          this.$refs.deviceList.doLayout();
        }
      })
    }
  },

  mounted() {
    this.getData()
    this.init();
  }
}
</script>

<style lang="scss" scoped>
.central-control {
  width: 100%;
  height: 100%;
}
.central-control-top {
  // width: 96%;
  height: 40px;
  display: flex;
  justify-content: flex-end;
}
.central-control-bottom {
  // width: 96%;
  height: calc(100% - 40px);
}
.central-control-container {
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.central-control-button {
  width: 12%;
  height: 5%;
  margin-left: 10%;
}
</style>